<template>
  <div class="equipment-container">
    <div class="navList">
      <div
        class="navItem"
        :class="{ active: current == index }"
        v-for="(item, index) in nav"
        :key="index"
        @click="navClick(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 搜索框 -->
    <div class="search-box">
      <div class="search-input">
        <input type="text" v-model="keyWords" placeholder="请输入关键字" />
      </div>
      <div class="search-btn" @click="search">搜索</div>
    </div>
    <!-- 列表 -->
    <div class="list">
      <vue-seamless-scroll :data="list" :class-option="defaultOption">
        <div class="list-group">
          <div
            class="list-item"
            :class="{ active: listCurrent == index }"
            v-for="(item, index) in list"
            :key="index"
            @mouseover="listOver(index)"
          >
            <div class="left">
              <div class="icon">
                <img
                  :src="
                    require('../../../assets/dispatch/' + item.icon + '.png')
                  "
                  alt=""
                />
              </div>
              <div>{{ item.name }}</div>
            </div>
            <div>查看轨迹</div>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
  import vueSeamlessScroll from 'vue-seamless-scroll'
  export default {
    components: {
      vueSeamlessScroll,
    },
    // 监听属性 类似于data概念
    computed: {
      defaultOption() {
        return {
          step: 0.4, // 数值越大速度滚动越快
          limitMoveNum: 13, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 500, // 单步运动停止的时间(默认值1000ms)
        }
      },
    },
    data() {
      return {
        nav: [
          {
            name: '全部',
            value: '',
            id: 0,
          },
          {
            name: '人员',
            value: '人员',
            id: 1,
          },
          {
            name: '车辆',
            value: '车辆',
            id: 2,
          },
          {
            name: '船只',
            value: '船',
            id: 3,
          },
        ],
        keyWords: '',
        current: 0,
        default: [
          {
            name: '人员测试1',
            icon: 'icon4',
          },
          {
            name: '车辆测试1',
            icon: 'icon5',
          },
          {
            name: '清心湖摆渡船',
            icon: 'icon6',
          },
          {
            name: '人员测试1',
            icon: 'icon4',
          },
          {
            name: '车辆测试1',
            icon: 'icon5',
          },
          {
            name: '清心湖摆渡船',
            icon: 'icon6',
          },
          {
            name: '人员测试1',
            icon: 'icon4',
          },
          {
            name: '车辆测试1',
            icon: 'icon5',
          },
          {
            name: '清心湖摆渡船',
            icon: 'icon6',
          },
          {
            name: '人员测试1',
            icon: 'icon4',
          },
          {
            name: '车辆测试1',
            icon: 'icon5',
          },
          {
            name: '清心湖摆渡船',
            icon: 'icon6',
          },
          {
            name: '车辆测试1',
            icon: 'icon5',
          },
          {
            name: '清心湖摆渡船',
            icon: 'icon6',
          },
        ],
        list: [],
        listCurrent: '',
      }
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.default))
    },
    mounted() {},
    methods: {
      // 导航点击
      navClick(index) {
        this.current = index
        this.keyWords = this.nav[index].value
        this.search()
      },
      // 列表悬浮
      listOver(index) {
        this.listCurrent = index
      },
      // 搜索
      search() {
        let arr = []
        this.default.forEach((item) => {
          if (item.name.indexOf(this.keyWords) !== -1) {
            arr.push(item)
          }
        })
        this.list = JSON.parse(JSON.stringify(arr))
      },
    },
  }
</script>
<style lang="scss" scoped>
  .equipment-container {
    padding: 0.78125vw;
    display: flex;
    flex-direction: column;
    height: 100%;
    .navList {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      .navItem {
        width: 3.6458vw;
        height: 1.5625vw;
        background: url('../../../assets/dispatch/btn.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        transition: all 0.5s;
      }
      .navItem.active {
        background: url('../../../assets/dispatch/btn-active.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    //   搜索框
    .search-box {
      display: flex;
      flex-direction: row;
      height: 1.875vw;
      border: 2px solid #49ba90;
      background-color: rgba(36, 217, 150, 0.2);
      color: white;
      margin: 1.0416vw 0;
      .search-input {
        flex-grow: 1;
        padding: 0 0.52083vw;
        input {
          outline: none;
          border: 0 none;
          height: 100%;
          width: 100%;
          background: none;
          color: white;
        }
        input::placeholder {
          color: #8cb6a3;
          font-size: 14px;
        }
      }
      .search-btn {
        border-left: 2px solid #49ba90;
        text-align: center;
        line-height: 1.875vw;
        background-color: rgba(36, 217, 150, 0.4);
        width: 4.63541vw;
        cursor: pointer;
        font-size: 14px;
      }
    }
    // 列表
    .list {
      height: 0;
      flex-grow: 1;
      overflow: hidden;
      .list-group {
        .list-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
          margin-top: 0.52083vw;
          color: white;
          font-size: 14px;
          height: 2.08333vw;
          padding: 0 0.52083vw;
          .left {
            display: flex;
            align-items: center;
            flex-direction: row;
            .icon {
              margin-right: 0.52083vw;
            }
          }
          .right {
            color: #00ffa2;
          }
        }
        .list-item.active {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
</style>
